import React, { useState } from "react";
import PageTitle from "components/PageTitle/PageTitle";
import { Button, CircularProgress, Grid } from "@material-ui/core";
import { Typography } from "components/Wrappers/Wrappers";

import Field from "components/CustomFields/Field.js";
import SelectField from "components/CustomFields/SelectField.js";
import DistributorAuthoritarianField from "components/CustomFields/DistributorAuthoritarianField";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";

import { dbGet, dbPost } from "utils/DBFetchers.js";
import { useHistory } from "react-router-dom";
import routes from "routes";

// styles
import useStyles from "./styles";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";

const blankNewDistributorForm = {
  id: "",
  name: "",
  authoritarian: null,
  programs: 1,
};

const allPrograms = [{ id: 1, name: "Receta solidaria" }];

export default function ABMDistributorsNewPage(props) {
  var classes = useStyles();
  var [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();

  const [newDistributorForm, updateForm] = useState(blankNewDistributorForm);
  const [allDistributors, setAllDistributors] = useState([]);
  const [isNameValid, setIsNameValid] = useState({ name: false, message: "" });
  const handleChange = (event) => {
    updateForm({
      ...newDistributorForm,
      [event.target.name]: event.target.value,
    });
  };

  const handleNameVerification = () => {
    var nameExists = allDistributors.some(
      (elem) => elem.name === newDistributorForm.name,
    );
    if (nameExists)
      setIsNameValid({
        name: nameExists,
        message: "Distribuidor ya existente.",
      });
    else setIsNameValid({ name: nameExists, message: "" });
  };

  React.useEffect(() => {
    if (!newDistributorForm.name) return; // no fetch on page load
    handleNameVerification();
  }, [newDistributorForm.name]);

  /* Fills distributor name options */
  const getDistributors = () => {
    dbGet("distributors").then((data) => {
      let mapped = data.map((item) => {
        return {
          id: item["id"],
          name: item["name"],
        };
      });
      setAllDistributors(mapped);
    });
  };

  /* Basic form check */
  const checkFormComplete = () => {
    if (
      !newDistributorForm.name ||
      !newDistributorForm.authoritarian
    )
      return false;
    return true;
  };

  /* Submit handling */
  const handleSubmit = () => {

    if (!checkFormComplete()) {
      snackbarOpen(
        "error",
        "Hay campos sin completar o incorrectos. Por favor completelos para poder añadir el distribuidor.",
      );
      return;
    }
    setIsLoading(true);

    // Give adecuate format to send form to db
    let completedForm = {
      name: newDistributorForm.name,
      works_with_independents: true,
      programs: [1],
      is_authoritarian: newDistributorForm.authoritarian === 1 ? true : false,
      use_wallet: true,
    };

    // Sends to db
    dbPost(`distributors`, completedForm)
      .then((data) => {
        snackbarOpen("success", "Distribuidor añadido exitosamente");
        redirectToDistributorsPage();
      })
      .catch((error) => {
        snackbarOpen(
          "error",
          error[0] ? error[0].description_es : "Error al añadir distribuidor", // translate pending
        );
        setIsLoading(false);
        return;
      });
  };

  /* Cancel editing distributor and go one page backwards */
  const cancelAndGoBack = () => {
    updateForm(blankNewDistributorForm);
    history.goBack();
  };

  /* Redirect to distributor table page after adding correctly */
  const redirectToDistributorsPage = (user) => {
    setTimeout(() => {
      updateForm(blankNewDistributorForm);
      setIsLoading(false);
      history.push(routes.abmDistributors);
    }, 2000);
  };

  /* On page load, get all data */
  React.useEffect(() => {
    getDistributors();
  }, []);

  const title = `Nuevo Distribuidor${newDistributorForm.name ? ": " : ""}${
    newDistributorForm.name ? newDistributorForm.name : ""
  }`;

  return (
    <>
      <div>
        <PageTitle
          title={title}
        />
      </div>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Grid
        style={{ display: "flex", margin: 0 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
      >
        <form autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.text}>
                Datos del distribuidor
              </Typography>
              <div
                className={classes.text}
                style={{
                  marginTop: "1%",
                  display: "flex",
                  justifyContent: "space-between",
                  width: 700,
                }}
              >
                <Typography weight="medium">
                  A continuación ingrese los datos del distribuidor a añadir.
                </Typography>
              </div>
              <div style={{ marginTop: "4%" }}>
                <Field
                  labelName="Nombre *"
                  required={true}
                  id="name"
                  value={newDistributorForm.name}
                  divClassType={classes.generalPurposeItems}
                  fieldClassType={classes.generalPurposeField}
                  onChange={handleChange}
                  error={isNameValid.name}
                  helperText={isNameValid.message}
                ></Field>
                <SelectField
                  divClassName={classes.generalPurposeItems}
                  fieldClassName={classes.generalPurposeField}
                  displayText="Programa/s *"
                  id="programs"
                  label="Seleccione"
                  name="programs"
                  value={newDistributorForm.programs}
                  disabled={true}
                  allValues={allPrograms ? allPrograms : []}
                />
                <DistributorAuthoritarianField
                  divClassName={classes.generalPurposeItems}
                  fieldClassName={classes.generalPurposeField}
                  value={newDistributorForm.authoritarian}
                  onChange={handleChange}
                />
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={10}>
            <Grid item xs={12}>
              <div className={classes.buttonSpacing}>
                {isLoading ? (
                  <CircularProgress size={26} className={classes.loginLoader} />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    Guardar
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={cancelAndGoBack}
                >
                  Cancelar
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
}
